import { render, staticRenderFns } from "./html-block-editor.vue?vue&type=template&id=b4b18fd8"
import script from "./html-block-editor.vue?vue&type=script&lang=ts"
export * from "./html-block-editor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports